<div
  *ngIf="question && !question.hidden"
  [formGroup]="form"
  [ngClass]="{ 'display-none': question?.hidden, 'display-grid': !question?.hidden }"
>
  <ng-container [ngSwitch]="question?.controlType">
    <ng-container *ngSwitchCase="'decorator'">
      <div *ngIf="!question?.hidden" [ngClass]="{ 'gl-forms__decorator': question.isDefaultClass }">
        <span *ngIf="question.value" [ngClass]="question.valueClass">{{ question.value | translate }}</span>
        <div *ngIf="$any(question).html" [ngClass]="question.valueClass" [innerHtml]="$any(question).html"></div>
        <gl-html-editor
          [id]="question.id"
          *ngIf="$any(question).wysiwyg"
          [value]="$any(question).wysiwyg"
          class="gl-forms__wysiwyg previewMode"
          [readOnly]="true"
        ></gl-html-editor>
        <gl-tooltip *ngIf="question?.tooltip" postop [text]="question?.tooltip | translate"></gl-tooltip>
        <gl-button
          *ngIf="question.buttonType === 'primary'"
          color-primary
          [text]="question.label | translate"
          [title]="question.label | translate"
          [attr.disabled]="question.disabled ? true : null"
          (onClick)="question.eventHandlers.click && question.eventHandlers.click($event, question)"
        >
        </gl-button>
        <gl-button
          *ngIf="question.buttonType === 'secondary'"
          color-secondary
          [text]="question.label | translate"
          [title]="question.label | translate"
          [attr.disabled]="question.disabled ? true : null"
          (onClick)="question.eventHandlers.click && question.eventHandlers.click($event, question)"
        >
        </gl-button>
        <gl-button
          *ngIf="question.buttonType === 'tertiary'"
          color-tertiary
          [attr.icon-left]="question.iconClass ? question.iconClass : null"
          [text]="question.label | translate"
          [title]="question.label | translate"
          [attr.disabled]="question.disabled ? true : null"
          (onClick)="question.eventHandlers.click && question.eventHandlers.click($event, question)"
        >
        </gl-button>
        <gl-button
          *ngIf="question.buttonType === 'icon'"
          icon
          [attr.icon-center]="question.iconClass ? question.iconClass : null"
          [attr.disabled]="question.disabled ? true : null"
          (onClick)="question.eventHandlers.click && question.eventHandlers.click($event, question)"
        >
        </gl-button>

        <gl-button
          *ngIf="question.buttonType === 'icon-secondary'"
          icon-secondary
          [attr.icon-center]="question.iconClass ? question.iconClass : null"
          [attr.disabled]="question.disabled ? true : null"
          (onClick)="question.eventHandlers.click && question.eventHandlers.click($event, question)"
        ></gl-button>
        <div *ngIf="question.separator" class="gl-forms__decorator--separator"></div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'tabgroup'">
      <div class="h3" *ngIf="question.title">{{ question.title | translate }}</div>
      <div class="group-tab">
        <mat-tab-group class="tab-group" animationDuration="0ms" disableRipple="true">
          <div *ngFor="let tab of question.tabs">
            <mat-tab *lmsProfileGuard="'groups.config.ranking.read'" label="{{ tab.label }} ">
              <ng-template mat-tab-label>{{ tab.label | translate }}</ng-template>
              <ng-template matTabContent>
                <lms-question
                  class="{{ tab.question?.class || 'col-1' }}"
                  [class.display-none]="tab.question?.hidden"
                  [question]="tab.question"
                  [form]="question.key ? form.controls[question.key] : form"
                  [action]="action"
                ></lms-question>
              </ng-template>
            </mat-tab>
          </div>
        </mat-tab-group>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'group'">
      <div
        *ngIf="!question.hideGroup"
        [ngClass]="{
          'gl-forms__section': question.isSection,
          'gl-forms__collapsible': question.isDropdown,
          collapsed: !$any(question).isOpenCollapsible && question.isDropdown
        }"
      >
        <div *ngIf="question?.hasHtml">
          <ng-content select="[form-html]"></ng-content>
        </div>
        <div *ngIf="question.childQuestions.length">
          <div class="gl-forms__title" *ngIf="question.title">
            {{ question.title | translate }}
            <gl-tooltip *ngIf="question?.tooltip" postop [text]="question?.tooltip | translate"></gl-tooltip>
          </div>
          <div class="gl-forms__subtitle" *ngIf="question.subtitle">{{ question.subtitle | translate }}</div>
          <div class="gl-forms__dropdown" *ngIf="question.isDropdown" (click)="$any(question).toggleCollapsible()">
            <span
              [ngClass]="{
                'glicon-down-arrow': !$any(question).isOpenCollapsible,
                'glicon-up-arrow': $any(question).isOpenCollapsible
              }"
            ></span>
          </div>
          <div
            class="{{ $any(question).gridClass }}"
            [ngClass]="{
              'gl-grid-form': !question.disableGrid,
              'gl-forms__collapsible--body': question.isDropdown
            }"
          >
            <ng-container *ngFor="let subquestion of question.childQuestions">
              <lms-question
                class="{{ subquestion?.class || 'col-1' }}"
                [class.display-none]="subquestion?.hidden"
                [question]="subquestion"
                [form]="question.key ? form.controls[question.key] : form"
                [action]="action"
              >
              </lms-question>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'textarea'">
      <gl-textarea
        [id]="question.id"
        [formControlName]="question.key"
        [skeletorValueAccessor]="question"
        [value]="question.value"
        [label]="question.label | translate"
        [placeholder]="question.placeholder | translate"
        [tooltip]="question.tooltip | translate"
        [showLengthValue]="question.validators.maxLength ? true : false"
        [maxLengthValue]="question.validators.maxLength"
        [heightBox]="question.heightBox"
        [mandatory]="question.validators?.required ? true : null"
        [attr.disabled]="question.disabled ? true : null"
        [attr.readonly]="!question.editable ? true : null"
        [attr.errorMessage]="errorMessage ? errorMessage : null"
      >
      </gl-textarea>
    </ng-container>

    <ng-container *ngSwitchCase="'textbox'">
      <gl-input
        type="text"
        [id]="question.id"
        [formControlName]="question.key"
        [skeletorValueAccessor]="question"
        [value]="question.value"
        [label]="question.label | translate"
        [placeholder]="question.placeholder | translate"
        [tooltip]="question.tooltip | translate"
        [selector]="question.selector"
        [attr.mandatory]="!question.hideRequiredMark && question.validators?.required ? true : null"
        [attr.minlength]="question.validators?.minLength"
        [attr.maxlength]="question.validators?.maxLength"
        [attr.disabled]="question.disabled ? true : null"
        [attr.readonly]="!question.editable ? true : null"
        [attr.small]="question.size === 'small' ? true : null"
        [errorMessage]="errorMessage"
        [icon]="question.iconClass"
      >
      </gl-input>
    </ng-container>

    <ng-container *ngSwitchCase="'number'">
      <gl-input
        type="number"
        [id]="question.id"
        [formControlName]="question.key"
        [skeletorValueAccessor]="question"
        [value]="question.value"
        [label]="question.label | translate"
        [placeholder]="question.placeholder | translate"
        [tooltip]="question.tooltip | translate"
        [selector]="question.selector"
        [attr.mandatory]="question.validators?.required ? true : null"
        [attr.min]="question.validators?.minValue?.limit"
        [attr.max]="question.validators?.maxValue?.limit"
        [attr.disabled]="question.disabled ? true : null"
        [attr.readonly]="!question.editable ? true : null"
        [attr.small]="question.size === 'small' ? true : null"
        [errorMessage]="(question.error | translate) || errorMessage"
      >
      </gl-input>
    </ng-container>

    <ng-container *ngSwitchCase="'passwordbox'">
      <gl-input
        type="password"
        [id]="question.id"
        [formControlName]="question.key"
        [skeletorValueAccessor]="question"
        [value]="question.value"
        [label]="question.label | translate"
        [placeholder]="question.placeholder | translate"
        [tooltip]="question.tooltip | translate"
        [selector]="question.selector"
        [attr.mandatory]="question.validators?.required ? true : null"
        [attr.disabled]="question.disabled ? true : null"
        [attr.readonly]="!question.editable ? true : null"
        [attr.small]="question.size === 'small' ? true : null"
        [errorMessage]="errorMessage"
      >
      </gl-input>
    </ng-container>

    <ng-container *ngSwitchCase="'link'">
      <gl-input
        type="text"
        [id]="question.id"
        [skeletorValueAccessor]="question"
        [value]="question.value"
        [selector]="question.selector"
        [attr.mandatory]="question.validators?.required ? true : null"
        [attr.disabled]="question.disabled ? true : null"
        [errorMessage]="errorMessage"
        link
      >
      </gl-input>
    </ng-container>

    <ng-container *ngSwitchCase="'datetime'">
      <gl-datepicker
        [id]="question.id"
        [formControlName]="question.key"
        [skeletorValueAccessor]="question"
        [value]="question.value"
        [label]="question.label | translate"
        [locale]="question.locale"
        [timezone]="question.timezone"
        [minDate]="question.minDate"
        [maxDate]="question.maxDate"
        [disableDates]="question.disableDates"
        [mode]="question.mode"
        [defaultHour]="question.defaultHour"
        [defaultMinute]="question.defaultMinute"
        [defaultSeconds]="question.defaultSeconds"
        [placeholder]="question.placeholder | translate"
        [tooltip]="question.tooltip | translate"
        [selector]="question.selector"
        [attr.enableTime]="question.enableTime ? true : null"
        [attr.inline]="question.inline ? true : null"
        [attr.mandatory]="question.validators?.required ? true : null"
        [attr.disabled]="question.disabled ? true : null"
        [attr.readonly]="!question.editable && !question.disabled ? true : null"
        [attr.small]="question.size === 'small' ? true : null"
        [errorMessage]="errorMessage"
      ></gl-datepicker>
    </ng-container>

    <ng-container *ngSwitchCase="'range'">
      <lms-range
        class="rangeForm"
        [id]="question.id"
        [config]="question.options.config"
        [formControlName]="question.key"
        (rangeSelected)="fireQuestionEvents($event)"
      ></lms-range>
    </ng-container>

    <ng-container *ngSwitchCase="'dropdown'">
      <gl-select
        [id]="question.id"
        [formControlName]="question.key"
        [skeletorValueAccessor]="question"
        [label]="question.label | translate"
        [placeholder]="question.placeholder | translate"
        [tooltip]="question.tooltip | translate"
        [attr.mandatory]="!question.hideRequiredMark && question.validators?.required ? true : null"
        [attr.disabled]="question.disabled ? true : null"
        [attr.readonly]="!question.editable ? true : null"
        [attr.multiselect]="question.multiple ? true : null"
        [attr.small]="question.size === 'small' ? true : null"
        [attr.autoWidth]="question.size === 'autoWidth' ? true : null"
        [options]="question.options"
        [value]="question.value"
        [separator]="question.separator"
        [errorMessage]="errorMessage"
      >
      </gl-select>
    </ng-container>

    <ng-container *ngSwitchCase="'switch'">
      <gl-switch
        [id]="question.id"
        [formControlName]="question.key"
        [skeletorValueAccessor]="question"
        [attr.checked]="question.value ? true : null"
        [label]="question.label | translate"
        [placeholder]="question.placeholder | translate"
        [tooltip]="question.tooltip | translate"
        [attr.disabled]="question.disabled ? true : null"
        [attr.readonly]="!question.editable ? true : null"
        [attr.secondary]="question.secondary ? true : null"
      >
      </gl-switch>
    </ng-container>

    <ng-container *ngSwitchCase="'checkbox'">
      <gl-checkbox
        [id]="question.id"
        [formControlName]="question.key"
        [skeletorValueAccessor]="question"
        [checked]="$any(question).isChecked()"
        [label]="question.label | translate"
        [placeholder]="question.placeholder | translate"
        [tooltip]="question.tooltip | translate"
        [attr.disabled]="question.disabled ? true : null"
        [attr.readonly]="!question.editable ? true : null"
        [attr.small]="!question.big ? true : null"
      >
      </gl-checkbox>
    </ng-container>

    <ng-container *ngSwitchCase="'radiobutton'">
      <gl-radiobutton
        [id]="question.id"
        [formControlName]="question.key"
        [skeletorValueAccessor]="question"
        [value]="question.value"
        [attr.disabled]="question.disabled ? true : null"
        [options]="question.options"
      >
      </gl-radiobutton>
    </ng-container>

    <ng-container *ngSwitchCase="'entity'">
      <gl-input-tag
        type="text"
        [id]="question.id"
        [formControlName]="question.key"
        [skeletorValueAccessor]="question"
        [value]="question.value"
        [label]="question.label | translate"
        [placeholder]="question.placeholder | translate"
        [tooltip]="question.tooltip | translate"
        [title]="question.title | translate"
        [optionLabel]="question.optionLabel | translate"
        [attr.clickTags]="question.clickTags ? true : null"
        [attr.mandatory]="question.validators?.required ? true : null"
        [attr.disabled]="question.disabled ? true : null"
        [attr.readonly]="!question.editable ? true : null"
        [attr.tagsLimit]="!question.entityOptions.multiple ? 1 : null"
        [attr.open]="question.open ? true : null"
        [attr.small]="question.size === 'small' ? true : null"
        [errorMessage]="errorMessage"
        [options]="question.options"
        [createTags]="question.entityOptions.freeEdit"
        [attr.dropdown]="question.entityOptions.dropdown"
      >
      </gl-input-tag>
    </ng-container>

    <ng-container *ngSwitchCase="'agents'">
      <div [ngClass]="{ 'gl-forms__section': question.isSection }">
        <div class="gl-forms__title" *ngIf="question.title">{{ question.title | translate }}</div>
        <div class="gl-grid-form">
          <gl-input
            type="hidden"
            class="display-none"
            [id]="question.id"
            [formControlName]="question.key"
            [skeletorValueAccessor]="question"
            [value]="question.value"
          ></gl-input>
          <div *ngFor="let subquestion of question.childQuestions" class="{{ subquestion?.class || 'col-1' }}">
            <gl-select
              [id]="subquestion.id"
              [label]="subquestion.label | translate"
              [placeholder]="subquestion.placeholder | translate"
              [formControlName]="subquestion.key"
              [skeletorValueAccessor]="subquestion"
              [tooltip]="subquestion.tooltip | translate"
              [attr.mandatory]="subquestion.validators?.required ? true : null"
              [attr.disabled]="subquestion.disabled ? true : null"
              [attr.readonly]="!subquestion.editable ? true : null"
              [attr.multiselect]="subquestion.multiple ? true : null"
              [attr.small]="question.size === 'small' ? true : null"
              [attr.autoWidth]="question.size === 'autoWidth' ? true : null"
              [errorMessage]="errorMessage"
              [options]="subquestion.options"
              [value]="subquestion.agentsIds"
              [separator]="subquestion.separator"
              (onChange)="subquestion.onChangeAgents($event.detail.value, question)"
            >
            </gl-select>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'publish'">
      <lms-clients-publish-selector id="{{ question.id }}" [formControlName]="question.key" [question]="question">
      </lms-clients-publish-selector>
    </ng-container>

    <ng-container *ngSwitchCase="'imagecropper'">
      <div class="form-field-separator">
        <lms-image-selector
          [formControlName]="question.key"
          [isDisabled]="question.disabled"
          [label]="question.label"
          [action]="question.action"
          [maxSizeInMB]="question.maxSizeMb"
          [data]="question.value"
        >
        </lms-image-selector>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'tags'">
      <gl-input-tag
        type="text"
        [id]="question.id"
        [formControlName]="question.key"
        [skeletorValueAccessor]="question"
        [value]="question.value"
        [label]="question.label | translate"
        [placeholder]="question.placeholder | translate"
        [tooltip]="question.tooltip | translate"
        [title]="'actions.select' | translate"
        [attr.clickTags]="question.clickTags ? true : null"
        [attr.mandatory]="question.validators?.required ? true : null"
        [attr.disabled]="question.disabled ? true : null"
        [attr.readonly]="!question.editable ? true : null"
        [attr.small]="question.size === 'small' ? true : null"
        [attr.tagsLimit]="question.options?.tagsLimit ? question.options.tagsLimit : null"
        [errorMessage]="errorMessage"
        [options]="question.options"
        [optionLabel]="'actions.selectTag' | translate"
      >
      </gl-input-tag>
    </ng-container>

    <label
      class="label"
      [attr.for]="question?.id"
      *ngIf="question?.key && question?.label && !question?.hideLabel && !question.designSystem"
      [ngClass]="{
        active: (question.value || question.control.value) && question.controlType.indexOf('dropdown') === -1
      }"
    >
      {{ question.label | translate }}
    </label>

    <ng-container *ngSwitchCase="'courses'">
      <lms-courses-selector
        [id]="question.id"
        [title]="question.label"
        [formControlName]="question.key"
        [courses]="question.courses"
        [hideButtons]="question.hideButtons"
        [unavailableCourses]="question.unavailableCourses"
        (coursesSelected)="fireQuestionEvents($event)"
      >
      </lms-courses-selector>
    </ng-container>

    <ng-container *ngSwitchCase="'documentsUploader'">
      <lms-documents-uploader
        [id]="question.id"
        [formControlName]="question.key"
        [maxSizeInMB]="question.maxSizeMb"
        [disabled]="question.disabled ? true : null"
        (documentSelected)="fireQuestionEvents($event)"
      >
      </lms-documents-uploader>
    </ng-container>

    <ng-container *ngSwitchCase="'imageuploadersmall'">
      <div class="form-field-separator">
        <lms-image-uploader-small
          [id]="question.id"
          [formControlName]="question.key"
          [cardImageUrl]="question.value"
          [maxSizeInMB]="question.maxSizeMb"
        ></lms-image-uploader-small>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'imageuploaderlarge'">
      <div class="form-field-separator">
        <lms-image-uploader-large
          [id]="question.id"
          [formControlName]="question.key"
          [bannerUrl]="question.value"
          [maxSizeInMB]="question.maxSizeMb"
        ></lms-image-uploader-large>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'imageuploaderpositioner'">
      <div class="form-field-separator">
        <lms-image-uploader-positioner
          [id]="question.id"
          [formControlName]="question.key"
          [getPosition]="question.value"
        ></lms-image-uploader-positioner>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'wysiwyg'">
      <label *ngIf="question?.label" class="heading-form active" [attr.for]="question?.id">
        {{ question.label | translate }}
      </label>
      <gl-html-editor
        [id]="question.id"
        [name]="question.id"
        class="gl-forms__wysiwyg margin-top-gap margin-bottom-gap"
        [skeletorValueAccessor]="question"
        [ngClass]="{ readonly: !question.editable }"
        [placeholder]="question.placeholder | translate"
        [formControlName]="question.key"
        [disabled]="question.disabled"
        [readOnly]="!question.editable"
        [focus]="question.editable"
        [toolbarOptions]="$any(question).toolbarItems"
        [value]="question.value"
      ></gl-html-editor>
    </ng-container>

    <ng-container *ngSwitchCase="'infoexpirationdate'">
      <lms-info-expiration-date [value]="question.value"></lms-info-expiration-date>
    </ng-container>

    <lms-dynamic-form-question-info
      *ngIf="
        question?.key && (question?.label || question?.tooltipKey) && !question?.hideLabel && !question.designSystem
      "
      [question]="question"
    >
    </lms-dynamic-form-question-info>
  </ng-container>

  <div class="gl-forms__error" *ngIf="!isValid && question?.controlType !== 'group' && !question.designSystem">
    <span class="glicon-alert-thin"></span>
    <span *ngFor="let error of errors">{{ error.message | translate : error.params }}</span>
  </div>
</div>
